import { useCallback } from 'react';
import { errorToast, successToast } from 'utils/helpers/notify';
import { errorHandler } from 'utils/helpers/errorHandler';
import { useEditObjectMutation } from '../../api/mutations/generated/EditObject';
import { useObject } from 'utils/api/useObject';

export const useFacilityMedicalInvoice = () => {
  const { object, id } = useObject();
  const [editObject] = useEditObjectMutation();

  const initialValues = {
    isMedInvoiceAllowed: object?.settings?.isMedicalBookWaitingEnabled || false,
    numberDaysWaitMedical: object?.settings?.medicalCertificateAllowedDays || undefined,
  };

  const validate = (values: typeof initialValues) => {
    const error: any = {};
    if (!values.numberDaysWaitMedical) {
      error.numberDaysWaitMedical = 'Обязательное поле';
    }
    return error;
  };

  const onSubmit = (values: typeof initialValues) => {
    if (!id) return;
    editObject({
      variables: {
        input: {
          objectId: id,
          settings: {
            isMedicalBookWaitingEnabled: values.isMedInvoiceAllowed,
            medicalCertificateAllowedDays: values.numberDaysWaitMedical,
          },
        },
      },
    })
      .then(() => successToast('Данные сохранены'))
      .catch(error => errorToast(errorHandler(error)));
  };

  const promotionSwitchOffHandler = useCallback(() => {
    if (!id) return;
    editObject({
      variables: {
        input: {
          objectId: id,
          settings: {
            isMedicalBookWaitingEnabled: false,
            medicalCertificateAllowedDays: 0,
          },
        },
      },
    })
      .then(() => successToast('Акция выключена'))
      .catch(error => errorToast(errorHandler(error)));
  }, [id, editObject]);

  return { initialValues, validate, onSubmit, promotionSwitchOffHandler };
};
